'use client';
import { useState } from 'react';

import { Card, CardContent } from '@/slw/shared/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/slw/shared/ui/accordion';

export function AccountSecurity() {
  const [open, setOpen] = useState(true);
  const triggerClass = 'md:pt-6 md:pb-4 py-4 text-sm md:text-base font-semibold leading-[100%] flex items-center';

  return (
    <Card className='rounded-2xl bg-[#F7F7F7] shadow-sm mb-8 border-0 p-6 md:p-8'>
      <div className='flex items-center justify-between'>
        <h3 className='text-xl md:text-[2rem] leading-[100%] font-bold text-foreground'>Account &amp; Security</h3>
        <button
          type='button'
          className='text-sm font-normal leading-[150%] text-muted-foreground hover:text-primary transition'
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>
      {open && (
        <CardContent className='pt-0 px-0 pb-0 min-h-[40px]'>
          <Accordion type='multiple' className='divide-y divide-[#E5E5E5]'>
            <AccordionItem value='is-my-information-secure'>
              <AccordionTrigger className={triggerClass}>Is my information secure?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Absolutely. We use modern encryption standards and do not store sensitive payment information on our
                servers. Our messaging system is private and monitored for abuse.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='reset-password'>
              <AccordionTrigger className={triggerClass}>How do I reset my password?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Click “Forgot Password” on the login page, and you’ll receive a secure link to reset your password via
                email.{' '}
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='delete-account'>
              <AccordionTrigger className={triggerClass}>Can I delete my account?</AccordionTrigger>
              <AccordionContent className='pl-0 text-sm leading-[150%]'>
                Yes. You can request account deletion at any time. [insert instructions about deletion and link to
                profile delete page]
              </AccordionContent>
            </AccordionItem>
          </Accordion>{' '}
        </CardContent>
      )}
    </Card>
  );
}
